export const OLERITE_FIND_ONE = 'OLERITE_FIND_ONE';
export const OLERITE_FIND_ONE_SUCCESS = 'OLERITE_FIND_ONE_SUCCESS';

export const OLERITE_CREATE = 'OLERITE_CREATE';
export const OLERITE_CREATE_SUCCESS = 'OLERITE_CREATE_SUCCESS';

export const OLERITE_UPDATE = 'OLERITE_UPDATE';
export const OLERITE_UPDATE_SUCCESS = 'OLERITE_UPDATE_SUCCESS';

export const OLERITE_CLEAR_SELECTED = 'OLERITE_CLEAR_SELECTED';

export const OLERITE_DELETE = 'OLERITE_DELETE';
